"use client";

import { GoogleAnalytics as GGoogleAnalytics } from "@next/third-parties/google";
import { useEffect, useState } from "react";
import { COOKIE_CONSENT_KEY } from "./cookie-consent";

const GA_TRACKING_ID = "G-3T3DKVG63D";

export function GoogleAnalytics() {
  const [shouldLoadGA, setShouldLoadGA] = useState(false);
  const [isAnalyticsEnabled, setIsAnalyticsEnabled] = useState(false);

  useEffect(() => {
    // Check if analytics should be enabled (only in browser)
    const analyticsEnabled =
      process.env.NODE_ENV === "production" &&
      (window.location.hostname === "articollect.io" ||
        window.location.hostname.endsWith(".articollect.io"));

    setIsAnalyticsEnabled(analyticsEnabled);

    const checkCookieConsent = () => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      setShouldLoadGA(consent === "accepted");
    };

    // Check initial consent status
    checkCookieConsent();

    // Listen for storage changes (when consent is updated)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === COOKIE_CONSENT_KEY) {
        setShouldLoadGA(e.newValue === "accepted");
      }
    };

    // Listen for custom events from the cookie consent component
    const handleConsentChange = (e: CustomEvent) => {
      setShouldLoadGA(e.detail === "accepted");
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener(
      "cookieConsentChange",
      handleConsentChange as EventListener,
    );

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(
        "cookieConsentChange",
        handleConsentChange as EventListener,
      );
    };
  }, []);

  // Only render GoogleAnalytics component if cookies are accepted and analytics is enabled
  if (!shouldLoadGA || !isAnalyticsEnabled) {
    return null;
  }

  return <GGoogleAnalytics gaId={GA_TRACKING_ID} />;
}
